import Cookies from "js-cookie";

const getSkills = async ({ commit, rootGetters, dispatch }, payload) => {
    commit("SET_SKILLS_LOADING", true);
    try {
        const customer = rootGetters["customer/CUSTOMER"];
        const selected_customer = rootGetters["customer/SELECTED_CUSTOMER"];
        const data = { ...payload, customer_id: customer.customer_id, userId: Cookies.get('userId') };

        if (customer.customer_id === 0) {
            data.customer_id = selected_customer.customer_id;
        }

        const response = await window.axios.get(`/proxy/ai/workspaces/${data.workspaceId}/skills?customer_id=${data.customer_id}`);

        if (response && response.data.success) {
            commit('SET_SKILLS', response.data.skills || []);
            return response.data.skills || [];
        } else {
            throw response.data;
        }
    } catch (error) {
        dispatch("notifications/setError", error.message || "Failed to load skills", { root: true });
        throw error;
    } finally {
        commit("SET_SKILLS_LOADING", false);
    }
};

export default getSkills;